import React from 'react';
import { useApp } from '../AppContext';

export default function Footer() {
  const { requestDashboard, goTo } = useApp();
  return (
    <footer className="bg-forestDark text-cream py-16 border-t border-sage/10">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="space-y-4 md:col-span-2">
          <img
            src={`${process.env.PUBLIC_URL}/logo-mark-light.webp`}
            alt="Logo Dr. Michele Balducci"
            width={343}
            height={295}
            className="h-16 w-auto -ml-1 mb-1 opacity-95"
          />
          <h4 className="font-serif text-2xl font-bold tracking-tight">Dr. Michele Balducci</h4>
          <p className="text-xs uppercase tracking-[0.2em] text-sage">Psicologo &amp; Psicoterapeuta · Consulenza Online</p>
          <p className="text-sm text-sageLight/75 max-w-sm leading-relaxed">
            Iscritto all'Ordine degli Psicologi del Lazio, n. 21747. Socio ordinario A.I.P.A. e I.A.A.P., socio S.I.I.P.E. P.IVA 13906801009. Riceve esclusivamente online tramite videoconferenza protetta.
          </p>
          <div className="pt-3 space-y-2 text-sm text-sageLight/80">
            <a href="tel:+393472208426" className="footer-link !block hover:text-cream smooth-transition">+39 347 2208426</a>
            <a href="mailto:m.balducci1987@gmail.com" className="footer-link !block hover:text-cream smooth-transition">m.balducci1987@gmail.com</a>
          </div>
        </div>

        <div className="space-y-4">
          <h5 className="text-xs uppercase tracking-[0.2em] text-sage font-bold">Link Rapidi</h5>
          <ul className="space-y-2 text-sm text-sageLight/80">
            <li><a href="#inizio" className="footer-link hover:text-cream smooth-transition">Inizio</a></li>
            <li><a href="#approccio" className="footer-link hover:text-cream smooth-transition">Il mio Approccio</a></li>
            <li><a href="#servizi" className="footer-link hover:text-cream smooth-transition">Servizi &amp; Tariffe</a></li>
            <li><a href="#faq" className="footer-link hover:text-cream smooth-transition">Domande Frequenti</a></li>
          </ul>
        </div>

        <div className="space-y-4">
          <h5 className="text-xs uppercase tracking-[0.2em] text-sage font-bold">Portale Clinico</h5>
          <p className="text-xs text-sageLight/70 leading-relaxed">Sezione ad uso esclusivo del Dr. Balducci per monitorare in tempo reale prenotazioni e appuntamenti.</p>
          <button
            onClick={requestDashboard}
            className="w-full bg-forest text-cream text-xs uppercase tracking-widest font-bold py-2.5 rounded-lg hover:bg-sage hover:text-forestDark smooth-transition"
          >
            Accedi all'Area Riservata
          </button>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-12 pt-8 border-t border-sage/10 flex flex-col sm:flex-row items-center justify-between text-xs text-sageLight/60 gap-4">
        <span>© 2026 Dr. Michele Balducci. Tutti i diritti riservati.</span>
        <div className="flex space-x-6">
          <button type="button" onClick={() => goTo('privacy')} className="footer-link hover:text-cream smooth-transition">Privacy Policy</button>
          <button type="button" onClick={() => goTo('cookie')} className="footer-link hover:text-cream smooth-transition">Cookie Policy</button>
          <button type="button" onClick={() => goTo('terms')} className="footer-link hover:text-cream smooth-transition">Termini del Servizio</button>
        </div>
      </div>
    </footer>
  );
}
